module.exports = __webpack_public_path__ + "img/job_offer.273d1e65.svg";